// extracted by mini-css-extract-plugin
module.exports = {"version":"SideNav--version--2nHKF"};